// extracted by mini-css-extract-plugin
module.exports = {"modalProgress":"UploadProgress_modalProgress__2_jzE","box":"UploadProgress_box__1In9R","loadingBar":"UploadProgress_loadingBar__3QGnj"};